import { render } from "./NavBlock.vue?vue&type=template&id=64aadbce&scoped=true"
import script from "./NavBlock.vue?vue&type=script&lang=js"
export * from "./NavBlock.vue?vue&type=script&lang=js"

import "./NavBlock.vue?vue&type=style&index=0&id=64aadbce&lang=scss&scoped=true"

import exportComponent from "/home/esesja/domains/app.esesja.mda.pl/public_html/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64aadbce"]])

export default __exports__